import { ImmutableObject } from "../../../../shared/immutableObject";

export abstract class PageUIData extends ImmutableObject {

  
}